export const MATERIAL_LABELS: Record<string, string> = {
  A1: "Low Density Polyethylene, 8MFR (LDPE-8melt)",
  A2: "Polypropylene (PP)",
  A3: "Regrind",
  B1: "Low Density Polyethylene, 8MFR (LDPE-8melt)",
  B2: "Linear Low Density Polyethylene (LLDPE)",
};

export const FLOW_LABELS = {
  flow1: "A Group (LDPE-8melt / PP / Regrind)",
  flow2: "B Group (LDPE-8melt / LLDPE)",
};
